import { handleCashPerAccount } from '../risk-data-per-account';

export const handleCash = (riskType: string, breakdowns: any[]) => {
  const hasAnyBooks = breakdowns.some((bk: any) => bk.book);

  if (!hasAnyBooks) {
    return handleCashPerAccount(riskType, breakdowns);
  }

  const globalCash = breakdowns.find(
    (bk: any) => bk.contract === 'CASH' && bk.instrument === 'ALL' && bk.book === 'ALL',
  );

  if (!globalCash) {
    return null;
  }

  const uniqueBooks = Array.from(
    new Set(
      breakdowns
        .filter((bk: any) => bk.contract === 'CASH' && bk.book !== 'ALL')
        .map((bk: any) => bk.book),
    ),
  );

  const bookNodes = uniqueBooks.map((bookName: string) => {
    const bookCash = breakdowns.find(
      (bk: any) => bk.contract === 'CASH' && bk.book === bookName && bk.instrument === 'TOTAL',
    );
    const bookValues = bookCash ? bookCash.risk : [];

    return {
      id: `${riskType}-cash-book-${bookName}`,
      label: bookName,
      position: bookCash.position,
      values: bookValues,
    };
  });

  return {
    id: `${riskType}-cash`,
    label: 'Cash',
    values: globalCash.risk,
    position: 'Position',
    children: bookNodes,
  };
};
